import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";
import RootSaga from "./Saga/RootSaga";
import RootSlice from "./Slice/RootSlice";
const sagaMiddleware = createSagaMiddleware();

const StoreConfig = configureStore({
  reducer: RootSlice,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});
sagaMiddleware.run(RootSaga);

export default StoreConfig;
